export default {
  title: {
    id: 'product_page_verified_refurbished_modal_title',
    defaultMessage: 'Verified Refurbished',
  },
  item1title: {
    id: 'product_page_verified_refurbished_modal_item_1_title',
    defaultMessage: 'Refurbished you can trust.',
  },
  item1text: {
    id: 'product_page_verified_refurbished_modal_item_1_text',
    defaultMessage:
      'Our rigorous vetting process means that only the best can sell on our platform. Just 1 out of every 3 sellers that apply to sell on Back Market make the cut.',
  },
  item2title: {
    id: 'product_page_verified_refurbished_modal_item_2_title',
    defaultMessage: 'Perfect working condition.',
  },
  item2text: {
    id: 'product_page_verified_refurbished_modal_item_2_text',
    defaultMessage:
      'Guaranteed by a minimum 25-point inspection conducted by industry professionals and a 1-year warranty. ',
  },
  item3title: {
    id: 'product_page_verified_refurbished_modal_item_3_title',
    defaultMessage: 'Better for the planet.',
  },
  item3text: {
    id: 'product_page_verified_refurbished_modal_item_3_text',
    defaultMessage:
      'You can fact check us. All our sustainability data comes from independently proven scientific research. ',
  },
  readMore: {
    id: 'product_page_verified_refurbished_modal_link',
    defaultMessage: 'Read the report',
  },
}
